import { z } from 'zod';

import { VALIDATION_MESSAGES } from '@/constants/constant';
import { stripHtml } from '@/utils';

export const addFaqSchema = z.object({
  question: z
    .string()
    .trim()
    .nonempty(VALIDATION_MESSAGES.faq.question.required)
    .min(2, VALIDATION_MESSAGES.faq.question.min)
    .max(200, VALIDATION_MESSAGES.faq.question.max),

  answer: z
    .string()
    .trim()
    .refine(
      (val) => {
        const text = stripHtml(val);
        return !!text;
      },
      { message: VALIDATION_MESSAGES.faq.answer.required }
    )
    .refine(
      (val) => {
        const text = stripHtml(val);
        return text && text.length >= 2;
      },
      { message: VALIDATION_MESSAGES.faq.answer.min }
    )
    .refine(
      (val) => {
        const text = stripHtml(val);
        return text && text.length <= 500;
      },
      { message: VALIDATION_MESSAGES.faq.answer.max }
    ),

  user_type: z
    .array(
      z
        .string()
        .trim()
        .nonempty({ error: VALIDATION_MESSAGES.faq.userType.required })
    )
    .min(1, VALIDATION_MESSAGES.faq.userType.required),
});

export type TAddFaqFormValues = z.infer<typeof addFaqSchema>;
